module.exports = __webpack_public_path__ + "static/media/icon_right.13d523ce.svg";